import React from 'react'
import Sidebardata from '../home/Sideebar'
import Header from '../home/header'
import Hero from './Hero'
import Contactform from './Contactform'


export default function index() {
    return (
        <>
            <div className='grid grid-cols-12  ' >
                <div className=' lg:col-span-2'>
                    <Sidebardata />
                </div>
                <div className=" transition-none col-span-12 lg:col-span-12 mr-3  ">
                    <div className=' w-[85%] sm:w-[95%] ml-auto ' >
                        <Header />
                        <Hero />
                        <Contactform />
                    </div>
                </div>
            </div>
        </>
    )
}
